import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

// Tikis.
import { Api } from '../common/constants/api';
import { ServerResponse } from '../models/RES/serverResponse';

@Injectable({
    providedIn: 'root'
})
export class LocalitiesService {
  constructor(
    private _http: HttpClient
  ) {}

  url: string = Api.Localities;

  public GetLocalitiesByState(dataId: number): Observable<ServerResponse> {
    return this._http.post<ServerResponse>(`${this.url}/GetLocalitiesByState`, dataId);
  }
}